import { Scope } from '@talpor/react-context-manager';

import { IStore } from '../index';

export interface IDashboardActions extends Scope<IStore> {
  switchView: (state: IStore) => (view: any) => IStore;
}

export const dashboardActions: IDashboardActions = {
  switchView: (state: IStore) => (currentView: any) => {
    return {
      ...state,
      dashboard: {
        ...state.dashboard,
        currentView,
      },
    };
  },
};
